module.exports = __webpack_public_path__ + "img/profpic.96e3310e.png";